import React, { Component } from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Cookies from 'universal-cookie';
import Tabs from 'muicss/lib/react/tabs';
import Tab from 'muicss/lib/react/tab';
import LoadingBoxes from '../components/loadingBoxes';
import LoadingText from '../components/loadingText';
import Card_Custom from '../components/card';
import ProfileSectionTop from '../components/profileSectionTop';
import ProfileSourceTab from '../components/profileSourceTab';
import RenderPopularBoxInfo from '../components/renderPopularBoxInfo';
import { fetch_kolprofile } from '../actions/fetch_kolprofile';
import { fetch_postlist } from '../actions/fetch_postlist';
import { numberWithCommas, reloadPage } from '../utility/tool';
import { userLogout } from '../utility/logout';
import '../styles/kolprofile.css';
import '../styles/k_sprite1.css';
import '../styles/posttype.css';
import '../styles/profileSourceTab.css';
import '../styles/spriteProfileTab.css';
import '../styles/sprite5.css';

let cookies = new Cookies();

class Profile extends Component {
	constructor(props){
		super(props)
	}

	componentDidMount(){
		window.scrollTo(0, 0)

		const { location } = this.props

		if(location.query.fid) {
			this.props.fetch_kolprofile(location.query, cookies.get('user_id'), cookies.get('token'))
			this.props.fetch_postlist(location.query.fid, 180, location.query.tags, 'FB,YT,IG', cookies.get('token'))
		}

	}

	checkEmptyTag(locationQuery, postlist){
		if(locationQuery.tags.length){
			return (
				<div className="keyword_post">
					<p className="sectionTitle">近半年關鍵字貼文</p>
					{this.renderKeywordBoxInfo(postlist.data)}
				</div>
			)
		}
	}

	renderKeywordBoxInfo(postlistData){
	    const keywordGroup = [];

	    postlistData.tag_post.forEach((item,index) => {
    	    keywordGroup.push(
    	    	<div className="keywordSection" key={index}>
    	    		<div className="keywordTitle">
    	    			<span className="k_sprite1 sprite-icon-arrow"></span>
    	    			<span className="keyword">符合關鍵字<span className="colorize">[{item.tag}]</span>的貼文</span>
    	    		</div>
    	    		<Card_Custom cardinfo={item.postlist} showSourceIcon={true}/>
    	    	</div>
    	    )
	    })

	    return (
	        <div>{keywordGroup}</div>
	    )
	}

  	render() {
		const {
			location,
			kolprofile,
			kolprofile_isloading,
			kolprofile_error,
			postlist,
			postlist_isloading,
			postlist_error,
		} = this.props;

		// show error message if no fid
		if(location.query.fid === ''){
  	  		return (
				<div className="errormsg">
					<p className="errormsgCenter">請重新點選KOL</p>
					<Link to="/" className="refreshBtn">
						<span className="refreshIconText">點我去首頁</span>
					</Link>
				</div>
  	  		)
		}

	  	if(kolprofile_isloading || postlist_isloading){
	  		return(
	  		  <div>
	  		    <LoadingBoxes />
	  		    <LoadingText />
	  		  </div>
	  		)
	  	}

		if(kolprofile.data === null || kolprofile.data === undefined){
  	  		return (
				<div className="errormsg">
					<p className="errormsgCenter">查無資料，請重新搜尋</p>
					<Link to="/" className="refreshBtn">
						<span className="refreshIconText">點我去首頁</span>
					</Link>
				</div>
  	  		)
		}

	  	if(kolprofile_error !== false || postlist_error !== false) {
			if(kolprofile_error.status === 401 || postlist_error.status === 401) {
				setTimeout(function(){ userLogout(); }, 3000);
				return <p className="errormsg">您的登入期間已過期，請重新登入</p>;
	  		} else {
	  	  		return (
					<div className="errormsg">
						<p className="errormsgCenter">資料未完成載入，請稍後再試</p>
						<div className="refreshBtn" onClick={() => {reloadPage()}}>
							<span className="refreshIcon"></span>
							<span className="refreshIconText">重新整理</span>
						</div>
					</div>
	  	  		)
	  		}
	  	}

	    return(
			<div className="profile_wrapper meta">
				<ProfileSectionTop leaderInfo={kolprofile.data.meta} />
				<ProfileSourceTab leaderInfo={kolprofile.data.meta} kolprofile={kolprofile.data.source}/>
				<div className="profile_post">
					{this.checkEmptyTag(location.query, postlist)}
					<div className="popular_post">
						<p className="sectionTitle">近半年熱門貼文</p>
						<RenderPopularBoxInfo postlist={postlist} />
					</div>
				</div>
	        </div>
	    )
   }

}

function mapStateToProps({ kolprofile, kolprofile_isloading, kolprofile_error, postlist, postlist_isloading, postlist_error }) {
  return { kolprofile, kolprofile_isloading, kolprofile_error, postlist, postlist_isloading, postlist_error };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ fetch_kolprofile, fetch_postlist }, dispatch);
}

export default connect(mapStateToProps,mapDispatchToProps )(Profile);



// WEBPACK FOOTER //
// ./src/containers/meta.js